<div class="background-image">
  <div class="overlay"></div>
  <div class="login-container" style="height: 100%" class="d-flex">
    <div class="image-container"></div>
    <div class="login-container login-container-large">
      <div class="login-card card-primary">
        <div class="card-body my-3">
          <div class="logo-container">
            <img
              src="../../../assets/img/alphastar-logo.png"
              alt="Centered Image"
              class="logo-image" />
          </div>
          <p class="login-box-msg">Sign in to start your session</p>

          <form [formGroup]="loginForm" class="mx-3" (ngSubmit)="loginByAuth()">
            <div class="input-group input-icons mb-4">
              <input
                formControlName="email"
                class="form-control pl-5"
                placeholder="Username" />
              <i class="fa m-1 z-index-100 fa-user icon"></i>
            </div>
            <div class="input-group input-icons mb-4">
              <input
                formControlName="password"
                type="password"
                class="form-control pl-5"
                placeholder="Password" />
              <i class="fa m-1 z-index-100 fa-lock icon"></i>
            </div>
            <div class="row">
              <div class="col">
                <button
                  mat-flat-button
                  class="login-button text-light w-100 btn pf-button">
                  <ng-container *ngIf="isAuthLoading; else submitText">
                    Sign In
                    <span
                      class="spinner-border spinner-border-sm ml-1"
                      role="status"
                      aria-hidden="true"></span>
                  </ng-container>
                </button>
                <ng-template #submitText> Sign In </ng-template>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="login-container-small">
      <div class="login-card-small card-primary">
        <div class="card-body my-3">
          <div class="logo-container">
            <img
              src="../../../assets/img/alphastar-logo.png"
              alt="Centered Image"
              class="logo-image" />
          </div>
          <p class="login-box-msg">Sign in to start your session</p>

          <form [formGroup]="loginForm" (ngSubmit)="loginByAuth()">
            <div class="input-group input-icons mb-3">
              <input
                formControlName="email"
                type="email"
                class="form-control pl-5"
                placeholder="Email" />
              <i class="fa m-1 z-index-100 fa-user icon"></i>
            </div>
            <div class="input-group input-icons mb-3">
              <input
                formControlName="password"
                type="password"
                class="form-control pl-5"
                placeholder="Password" />
              <i class="fa m-1 z-index-100 fa-lock icon"></i>
            </div>
            <div class="row">
              <div class="col">
                <button
                  mat-flat-button
                  class="login-button text-light w-100 btn pf-button">
                  <ng-container *ngIf="isAuthLoading; else submitText">
                    Sign In
                    <span
                      class="spinner-border spinner-border-sm ml-1"
                      role="status"
                      aria-hidden="true"></span>
                  </ng-container>
                </button>
                <ng-template #submitText> Sign In </ng-template>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
